import { API, APIResultList, Item } from "@thenounproject/lingo-core";

import { createAsyncAction } from "../actionCreators";

/**
 * Batch updates an array of item ids with a new status
 * @param {Array} items Array of objects containing item id
 * @param {String} status trashed | deleted | active
 */
type Args = {
  items: string[];
  status: Item["status"];
};

const [useBatchUpdateItemStatus, batchUpdateItemStatus] = createAsyncAction(
  {
    action: "items/batchUpdateItemStatus",
    undo: {
      message: (args: Args) => `Trashed ${args.items.length} item(s)`,
      condition: (args: Args) => args.status !== "deleted",
      performUndo: (args: Args, _: unknown, { dispatch }) => {
        void dispatch(batchUpdateItemStatus({ items: args.items, status: "active" }));
      },
    },
  },
  async ({ items, status }: Args) => {
    return await API.call<APIResultList<"items", string>>({
      endpoint: "sync/items",
      method: "POST",
      data: {
        items: items.map(id => ({ uuid: id, status })),
      },
    });
  }
);
export default useBatchUpdateItemStatus;
export { batchUpdateItemStatus };
